import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-center items-center"
};
const _hoisted_2 = {
  class: "slide-captcha"
};
const _hoisted_3 = {
  class: "bg-img"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "block"
};
const _hoisted_6 = {
  class: "verify"
};
const _hoisted_7 = {
  class: "verify-bar-area"
};
const _hoisted_8 = {
  class: "verify-msg"
};
import { onMounted, ref, watch } from "vue";
import { ArrowRightBold, CircleCheckFilled, CircleCloseFilled, Refresh } from "@element-plus/icons-vue";

// eslint-disable-next-line no-undef

export default {
  __name: 'SlideCaptcha',
  props: {
    bgImg: String,
    bkImg: String,
    result: Number
  },
  emits: ["confirm", "refresh", "hide"],
  setup(__props, {
    emit: __emit
  }) {
    // eslint-disable-next-line no-undef
    const props = __props;
    const verifyText = ref("向右滑动完成验证");
    const verifyMsg = ref("");
    const verifyMsgClass = ref("verify-text success");
    const blockClass = ref("verify-move-block");
    const leftBarClass = ref("verify-left-bar");
    const backgroundImg = ref("");
    const blockImg = ref("");
    const leftBarWidth = ref(0);
    const blockLeft = ref(0);
    const checked = ref(0);
    const time = ref("");
    watch(() => props.bgImg, newVal => {
      backgroundImg.value = newVal;
    });
    watch(() => props.bkImg, newVal => {
      blockImg.value = newVal;
    });
    watch(() => props.result, newVal => {
      checked.value = newVal;
      if (newVal === 1) {
        verifyMsgClass.value = "verify-text success";
        blockClass.value = "verify-move-block success";
        leftBarClass.value = "verify-left-bar success";
        verifyMsg.value = "验证成功";
        setTimeout(() => emits("hide"), 1000);
      } else if (newVal === 2) {
        verifyMsgClass.value = "verify-text error";
        blockClass.value = "verify-move-block error";
        leftBarClass.value = "verify-left-bar error";
        verifyMsg.value = "验证失败";
        setTimeout(() => {
          reset();
          emits("refresh");
        }, 1000);
      } else {
        reset();
      }
    });

    // eslint-disable-next-line no-undef
    const emits = __emit;
    let offsetX = 0,
      isDragging = false;
    let start = 0;
    onMounted(() => {
      const dragBlock = document.getElementById("dragBlock");
      dragBlock.addEventListener("mousedown", evt => {
        blockClass.value = "verify-move-block active";
        leftBarClass.value = "verify-left-bar active";
        leftBarWidth.value = 32;
        isDragging = true;
        verifyText.value = "";
        offsetX = evt.clientX;
        start = new Date().getTime();
        evt.preventDefault();
      });
      document.body.addEventListener("mousemove", evt => {
        if (!isDragging) {
          return;
        }
        const x = Math.max(evt.clientX - offsetX, 0);
        blockLeft.value = x;
        leftBarWidth.value = x + 32;
      });
      document.body.addEventListener("mouseup", () => {
        if (!isDragging) {
          return;
        }
        time.value = ((new Date().getTime() - start) / 1000).toFixed(2);
        isDragging = false;
        emits("confirm", Math.floor(blockLeft.value));
      });

      // 触摸事件
      dragBlock.addEventListener("touchstart", function (e) {
        isDragging = true;
        blockClass.value = "verify-move-block active";
        leftBarClass.value = "verify-left-bar active";
        leftBarWidth.value = 32;
        isDragging = true;
        verifyText.value = "";
        offsetX = e.touches[0].clientX - dragBlock.getBoundingClientRect().left;
        start = new Date().getTime();
        e.preventDefault();
      });
      document.addEventListener("touchmove", function (e) {
        if (!isDragging) {
          return;
        }
        e.preventDefault();
        const x = Math.max(e.touches[0].clientX - offsetX, 0);
        blockLeft.value = x;
        leftBarWidth.value = x + 32;
      });
      document.addEventListener("touchend", function () {
        if (!isDragging) {
          return;
        }
        time.value = ((new Date().getTime() - start) / 1000).toFixed(2);
        isDragging = false;
        emits("confirm", Math.floor(blockLeft.value));
      });
    });

    // 重置验证码
    const reset = () => {
      blockClass.value = "verify-move-block";
      leftBarClass.value = "verify-left-bar";
      leftBarWidth.value = 0;
      blockLeft.value = 0;
      checked.value = 0;
      verifyText.value = "向右滑动完成验证";
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
        src: backgroundImg.value
      }, null, 8, ["src"]), checked.value !== 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(verifyMsgClass.value)
      }, [checked.value === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(time.value) + "s", 1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(verifyMsg.value), 1)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "refresh",
        onClick: _cache[0] || (_cache[0] = $event => emits('refresh'))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Refresh))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_5, [_createVNode(_component_el_image, {
        src: blockImg.value,
        style: _normalizeStyle({
          left: blockLeft.value + 'px'
        })
      }, null, 8, ["src", "style"])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(verifyText.value), 1), _createElementVNode("div", {
        class: _normalizeClass(leftBarClass.value),
        style: _normalizeStyle({
          width: leftBarWidth.value + 'px'
        })
      }, [_createElementVNode("div", {
        class: _normalizeClass(blockClass.value),
        id: "dragBlock",
        style: _normalizeStyle({
          left: blockLeft.value + 'px'
        })
      }, [checked.value === 0 ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_unref(ArrowRightBold))]),
        _: 1
      })) : _createCommentVNode("", true), checked.value === 1 ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_unref(CircleCheckFilled))]),
        _: 1
      })) : _createCommentVNode("", true), checked.value === 2 ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 2
      }, {
        default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
        _: 1
      })) : _createCommentVNode("", true)], 6)], 6)])])])]);
    };
  }
};